<template>
 <div>
   <h1>{{ title}}</h1>
   <form class="form-signin">
  <img class="mb-4" src="/docs/4.6/assets/brand/bootstrap-solid.svg" alt="" width="72" height="72">
  <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>
  <label for="inputEmail" class="sr-only">Email address</label>
  <input type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus>
  <label for="inputPassword" class="sr-only">Password</label>
  <input type="password" id="inputPassword" class="form-control" placeholder="Password" required>
  <div class="checkbox mb-3">
    <label>
      <input type="checkbox" value="remember-me"> Remember me
    </label>
  </div>
  <button class="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>
  <p class="mt-5 mb-3 text-muted">&copy; 2017-2021</p>
  <div>

  </div>
</form>

 </div>
</template>

<script>
import {app} from '@/main'
import NavBar from '@/components/NavBar'
import HomeForm from '@/components/HomeForm'
export default {
  name: 'HomeForm',
  components:{
     NavBar,HomeForm
  },
  data () {
    return {
     title: '首頁',
      posts:''
    }
  },
   methods:{
    //語言
    changeLang(lang){
    app.$i18n.locale=lang
    },

     //Axios
    getValue(){
      const vm =this;
      const api =`${process.env.APIPATH}/posts`;
     //  console.log(process.env.APIPATH,process.env.APIPSD)
      this.$http.get(api).then((response) => {
        console.log(response.data)
        this.posts=response.data;
        
       
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/HomeForm.vue